import { useBasicGiftCardContext } from '@/src/common/contexts/BasicGiftCardContext'
import { BACStep1Body } from '@/src/modules/build-a-card/StyledComponents'
import Card from '@/src/common/components/marketing/cards/Card'
import { ClickableWrapper } from '@/src/modules/cart/StyledComponents'
import { useState } from 'react'
import { PredesignsModal } from '../../modals/PredesignsModal'
import { DesktopOnly } from '@/src/common/utilities/viewportDisplay'
import ActionButtons from '@/src/modules/build-a-card/physical/content/ActionButtons'
import ShippingAndUsageContent from './ShippingAndUsageContent'
import InterestedInText from '@/src/common/components/marketing/text/InterestedInText'

const DesignGiftStep = ({
    setPlaceholderClicked,
}: {
    setPlaceholderClicked: Function
}) => {
    const {
        defaultImage,
        defaultToPredesign,
        nameOnCard,
        messageOnCard,
        designName,
        designImage,
        setDesignImage,
        setDesignName,
        setCustomDesignObject,
        predesignUuid,
        setPredesignUuid,
        predesigns,
        setSelectedImageType,
    } = useBasicGiftCardContext()

    const [predesignsModalIsOpen, setPredesignsModalIsOpen] =
        useState<boolean>(false)

    return (
        <>
            <h1 style={{ margin: '20px 0px 0px' }}>
                {defaultToPredesign ? 'Choose a design for' : 'Personalize'}{' '}
                your <span className={'gradient'}>Plastic Visa gift card!</span>
            </h1>
            <InterestedInText
                linkToPlastic={false}
                style={{ marginBottom: 25 }}
            />
            {defaultToPredesign ? (
                <>
                    <ClickableWrapper
                        onClick={() => setPredesignsModalIsOpen(true)}
                    >
                        <Card
                            size={'lg-with-xs-mobile'}
                            image={designImage ? designImage : defaultImage}
                            isExtended={!designImage}
                            message={
                                messageOnCard ? messageOnCard : 'Custom message'
                            }
                            name={nameOnCard ? nameOnCard : 'Recipient name'}
                            overlayType={'full'}
                            setPlaceholderClicked={
                                !designImage ? setPlaceholderClicked : null
                            }
                            showLoader={!designName}
                            borderRadius={!designImage ? 0 : 12}
                            priority={true}
                        />
                    </ClickableWrapper>
                    <PredesignsModal
                        isOpen={predesignsModalIsOpen}
                        setIsOpen={setPredesignsModalIsOpen}
                        setDesignImage={setDesignImage}
                        setCustomDesignObject={setCustomDesignObject}
                        predesignUuid={predesignUuid}
                        setPredesignUuid={setPredesignUuid}
                        predesigns={predesigns}
                        setDesignName={setDesignName}
                        setSelectedImageType={setSelectedImageType}
                    />
                </>
            ) : (
                <Card
                    size={'lg-with-xs-mobile'}
                    image={designImage ? designImage : defaultImage}
                    isExtended={!designImage}
                    message={messageOnCard ? messageOnCard : 'Custom message'}
                    name={nameOnCard ? nameOnCard : 'Recipient name'}
                    overlayType={'full'}
                    setPlaceholderClicked={
                        !designImage ? setPlaceholderClicked : null
                    }
                    showLoader={!designName}
                    borderRadius={!designImage ? 0 : 12}
                    priority={true}
                />
            )}

            <DesktopOnly>
                <BACStep1Body>
                    <ShippingAndUsageContent
                        showPredesignMessage={defaultToPredesign}
                    />
                    <ActionButtons defaultToPredesign={defaultToPredesign} />
                </BACStep1Body>
            </DesktopOnly>
        </>
    )
}

export default DesignGiftStep
